import React, { PropTypes } from 'react';
import { defaultThumbnail } from 'utils/assets';
import AsyncImage from 'common/components/AsyncImage';

const getImageUrl = entity => {
  if (entity.image) {
    return entity.image.web;
  }

  return defaultThumbnail();
};

const EntityImage = ({ entity }) => (
  <AsyncImage src={getImageUrl(entity)} className="ui tiny rounded image" />
);

EntityImage.propTypes = {
  entity: PropTypes.object.isRequired,
};

export default EntityImage;



// WEBPACK FOOTER //
// ./src/modules/catalog/components/EntityImage.js